import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import img1 from "../../../assets/img/warehouseStructure/warehouseThree/warehouseThree-bg2.webp";

import VisibilitySensor from "react-visibility-sensor";

function WarehouseThree(){

    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);

    const onChange = (visibility) => {
      if (visibility) {
        setIsVisible(true);
      }
    };

    return(
        <VisibilitySensor onChange={onChange} partialVisibility minTopValue={100}>
          <div className={`warehouseThree ${isVisible ? 'visible' : ''}`}>
            <h1 className={`${isVisible ? 'visible' : ''}`}>{t("warehouse_three_title")}</h1>
            <p className={`${isVisible ? 'visible' : ''}`}>
              {t("warehouse_three_text")}
            </p>
            <img className={`${isVisible ? 'visible' : ''}`} src={img1} alt="" />
          </div>
        </VisibilitySensor>
    )
}
export default WarehouseThree;